<template>
  <Modal title="商品分类" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="cateInfo"  :model='cateInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="分类名称" prop="category_name">
              <Input placeholder="请输入" v-model="cateInfo.category_name"></Input>
            </form-item>
          <form-item label="排序" prop="sort">
            <InputNumber :min="0" v-model="cateInfo.sort"></InputNumber>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('cateInfo')" :loading="loading">
          <span v-if="!loading">提交</span>
          <span v-else>提交中...</span>
        </Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { addCate, cateInfo } from '@/api/supply/category'
import Setting from '@/setting'
export default {
  name: 'categoryEdit',
  props: ['id'],
  data () {
    return {
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      uploadList: [], // 缩咯图
      imgUrl: '',
      visible: false,
      pidArr: [],
      isShow: false,
      loading: false,
      category_id: 0,
      cateInfo: {
        category_id: 0,
        pid: [],
        pic: '',
        category_name: '',
        sort: 0,
        delpics: [] // 服务器待删除的照片
      },
      ruleValidate: {
        category_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    id (val) {
      this.category_id = val
      if (this.category_id > 0) {
        this.getCateInfo()
      } else {
        this.cateInfo = {
          category_id: 0,
          pid: [],
          pic: '',
          category_name: '',
          sort: 0,
          delpics: [] // 服务器待删除的照片
        }
        this.uploadList = []
      }
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    handleOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          addCate(this.cateInfo).then(res => {
            let msg = '添加成功'
            if (this.cateInfo.category_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.isShow = false
              this.$emit('updateStatusModel')
            } else {
              this.$Message.error(res.msg)
              this.loading = false
            }
          }).catch(res => {
            this.$Message.error(res.msg)
            this.loading = false
          })
        }
      })
    },
    getCateInfo () {
      cateInfo(this.category_id).then(res => {
        this.cateInfo = res.data
        this.uploadList = []
        this.uploadList.push({ 'url': this.cateInfo.pic, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.cateInfo.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.server_url + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    }
  }
}
</script>
